module.exports = __webpack_public_path__ + "img/house_15.234a927b.jpg";